"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPrintable = void 0;
exports.isPrintableProduct = isPrintableProduct;
exports.isPrintableEmpty = isPrintableEmpty;
exports.hasEmptyUserPhotoLayer = hasEmptyUserPhotoLayer;
exports.hasFilledUserPhotoLayer = hasFilledUserPhotoLayer;
exports.isPartiallyFilledPrintable = isPartiallyFilledPrintable;
exports.clearPrintable = clearPrintable;
exports.generatePrintableVersion = generatePrintableVersion;
exports.updatePrintableVersion = updatePrintableVersion;
exports.mutablyUpdatePrintableVersion = mutablyUpdatePrintableVersion;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const uuid_1 = require("uuid");
const typeguard_1 = require("./../../types/typeguard");
const EditableTextLayer_1 = require("../layers/EditableTextLayer");
const Layer_1 = require("./../layers/Layer");
const CoverSurface_1 = require("../CoverSurface");
const TemplateSurface_1 = require("../TemplateSurface");
const UserPhotoLayer_1 = require("./../layers/UserPhotoLayer");
const EditableDesignAssetLayer_1 = require("../layers/EditableDesignAssetLayer");
const DesignAssetLayer_1 = require("../layers/DesignAssetLayer");
function isPrintableProduct(p) {
  return p && p.options && p.options.design && typeof p.options.design === 'string';
}
const printableRuleSet = {
  id: typeguard_1.isNonEmptyString,
  createdAt: typeguard_1.isNonEmptyString,
  lastModifiedAt: typeguard_1.isNonEmptyString,
  lastModifiedBy: typeguard_1.isNonEmptyString,
  lastModifiedByAdmin: typeguard_1.isBool,
  surface: val => (0, TemplateSurface_1.isTemplateSurface)(val) || (0, CoverSurface_1.isCoverSurface)(val),
  designId: typeguard_1.isNonEmptyString,
  vendorCoverDesignId: (0, typeguard_1.optional)(typeguard_1.isNonEmptyString),
  isCompositeDesign: (0, typeguard_1.optional)(typeguard_1.isBool),
  layers: val => Array.isArray(val) && val.reduce((acc, curr) => acc && (
  // Checking for badge type layers is still necessary as the badge layer and base layer do not fully overlap.
  // Older projects will still have badge layers and will thus fail the type guard if this check isn't included here
  curr && curr.type === 'badge' || (0, Layer_1.isLayer)(curr) || (0, UserPhotoLayer_1.isUserPhotoLayer)(curr) || (0, EditableTextLayer_1.isEditableTextLayer)(curr) || (0, DesignAssetLayer_1.isDesignAssetLayer)(curr) || (0, EditableDesignAssetLayer_1.isEditableDesignAssetLayer)(curr)), true),
  product: val => val ? isPrintableProduct(val) : true,
  version: val => (0, typeguard_1.isNonEmptyString)(val) || (0, typeguard_1.isNumber)(val),
  parentId: typeguard_1.isNonEmptyString
};
const isPrintable = p => (0, typeguard_1.isType)(p, printableRuleSet);
exports.isPrintable = isPrintable;
function isPrintableEmpty(printable) {
  return printable.layers.filter(UserPhotoLayer_1.isUserPhotoLayer).every(l => l.userData == null);
}
function hasEmptyUserPhotoLayer(printable) {
  return printable.layers.some(l => (0, UserPhotoLayer_1.isUserPhotoLayer)(l) && !l.userData);
}
function hasFilledUserPhotoLayer(printable) {
  return printable.layers.some(l => (0, UserPhotoLayer_1.isUserPhotoLayer)(l) && l.userData);
}
function isPartiallyFilledPrintable(printable) {
  return hasEmptyUserPhotoLayer(printable) && hasFilledUserPhotoLayer(printable);
}
function clearPrintable(printable) {
  return Object.assign(Object.assign({}, printable), {
    layers: printable.layers.map(layer => {
      if ((0, UserPhotoLayer_1.isUserPhotoLayer)(layer)) {
        return (0, UserPhotoLayer_1.clearUserPhotoLayer)(layer);
      } else {
        return layer;
      }
    })
  });
}
function generatePrintableVersion(timestamp, id) {
  return (0, uuid_1.v5)(timestamp, id);
}
function updatePrintableVersion(printable, timestamp) {
  const newPrintable = (0, lodash_clonedeep_1.default)(printable);
  newPrintable.version = generatePrintableVersion(timestamp, printable.id);
  newPrintable.lastModifiedAt = timestamp;
  return newPrintable;
}
function mutablyUpdatePrintableVersion(printable, timestamp) {
  const printableToMutate = printable;
  printableToMutate.version = generatePrintableVersion(timestamp, printable.id);
  printableToMutate.lastModifiedAt = timestamp;
}